export enum TitleStatusEnum {
  'Em Cobrança' = 0,
  'Quitado' = 1,
  'Protestado' = 2,
  'Sustar Protesto' = 3,
  'Não Protestar' = 4,
  'Em Cartório' = 5,
}
